import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CaptchaDto } from '@shared/dtos/captcha.dto';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private readonly baseUrl: string =
    this.configService.getApiBaseUrl() + '/captcha';

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {}

  getCaptcha(): Observable<CaptchaDto> {
    return this.httpClient.get<CaptchaDto>(this.baseUrl);
  }
}
